import React from 'react';
import { Svg } from 'app/components/common';
import PropTypes from 'prop-types';
import { Constants } from 'app/utilities';
import { buttonEventClick } from 'clevertap/LogEvent';
import Event from 'clevertap/Event';
import QuickCard from '../QuickCard';
import ReverseTimer from '../ReverseTimer';

const style = {
  slide_wrapper: {
    border: 'none',
    background: 'transparent',
    position: 'relative',
  },
  video_wrapper: {
    position: 'relative',
    border: 'none',
    background: 'transparent',
  },
  play_button: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -70%)',
    border: 'none',
    background: 'none',
  },
};

const BannerMiddle = ({
  banners, setBrandVideoLink, toggleVideoModal, captureBannerClicked, history, language,
}) => (
  <>
    {/* it's an image */}
    {
        banners.map((banner) => (
          (banner.bannerLocation === 'BANNER_MIDDLE' && !banner.videoLink)
            ? (
              <>
                <button
                  key={banner.bannerId}
                  type="button"
                  style={style.slide_wrapper}
                  onClick={() => {
                    buttonEventClick(
                      Event.LL_Banner_Clicked,
                      {
                        Page: 'Home_Tab',
                        'Banner name': banner.title,
                        Section: 'Middle Banner',
                      },
                    );
                    if (banner.isFreeSampleBanner) {
                      history.push({
                        pathname: '/shops',
                        state: {
                          filterCategoryId: 'FREESAMPLE',
                          filterId: 'FREE_SAMPLE',
                          scrollToTop: true,
                        },
                      });
                      return;
                    }
                    history.push(banner.deepLink.web);
                  }}
                >
                  { banner.isFreeSampleBanner === true
                    ? (
                      <span className="timer_wrapper_mb fs-4 d-flex align-items-center font-weight-bold">
                        <Svg
                          svg="clock"
                          width="30px"
                          height="30px"
                          fill={Constants.Color.black}
                          stroke={Constants.Color.black}
                          stroke1={Constants.Color.yellow}
                        />
                        {Constants.String.OFFER_ENDS_IN[language]}
                        <ReverseTimer
                          targetDate={banner.expiryDate}
                        />
                      </span>
                    ) : null}
                  <QuickCard
                    name={banner.title}
                    image={banner.image}
                    cardStyle={
                    {
                      width: '320px',
                      height: '180px',
                      overflow: 'hidden',
                      borderRadius: '16px',
                    }
                  }
                  />
                </button>
              </>
            ) : null
        ))
      }
    {/* it's a video */}
    {
        banners.map((banner) => (
          (banner.bannerLocation === 'BANNER_MIDDLE' && banner.videoLink)
            ? (
              <button
                key={banner.bannerId}
                type="button"
                style={style.video_wrapper}
                onClick={() => {
                  setBrandVideoLink(banner);
                  toggleVideoModal();
                  captureBannerClicked(banner);
                }}
              >
                <QuickCard
                  name={banner.title}
                  image={banner.image}
                  cardStyle={
                  {
                    width: '320px',
                    height: '180px',
                    overflow: 'hidden',
                    borderRadius: '16px',
                  }
                }
                />
                <div style={style.play_button}>
                  <Svg
                    svg="playNew"
                    width="30px"
                    fill="#fff"
                  />
                </div>
              </button>
            ) : null
        ))
      }
  </>
);

BannerMiddle.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({})),
  setBrandVideoLink: PropTypes.func,
  toggleVideoModal: PropTypes.func,
  captureBannerClicked: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
  language: PropTypes.string.isRequired,
};

BannerMiddle.defaultProps = {
  banners: [],
  setBrandVideoLink: () => { },
  toggleVideoModal: () => { },
  captureBannerClicked: () => { },
};

export default BannerMiddle;
